<template>
<div class="chapter">
<div class="inner_page">
<div id="the-blessing-prayer">
<div class="story">
<div class="image2"><img alt="Envelope.tif" class="frame-1" src="images/Envelope_fmt.gif"/></div>
<p class="ital-cntr"><span class="ital">Above is a scan of the battered manila envelope that this manuscript was found in.</span></p>
<a id="anchor-anchor"><p class="ahead"><span class="generated-style">The Blessing Prayer</span></p>
<p class="txnoi"><span class="generated-style">In the name of Dryghtyn, the Ancient Providence, <br/>which was from the beginning and is for eternity <br/>male and female, the original source of all things: <br/>all-knowing, all-pervading, all-powerful, changeless, <br/>eternal; in the names of the Lady of the Moon <br/>and our Lord the Horned One; in the names of the Spirits <br/>of the Stones, rulers of the elemental realms: <br/>Bless this place, and this time, and they who are <br/>with us.*</span></p>
<p class="normal"><span class="generated-style">(to be said before every rite, just after building the Circle of Stones)</span></p>
<p class="txnoi"><span class="generated-style">* Scott Cunningham had a second version of this blessing prayer, in which he added deity names: “the Lady of the Moon, Diana, and our Lord the Horned One, Kernunnos.”</span></p>
</a><p class="contents"><a id="anchor-anchor"><span class="generated-style"></span></a><a href="#/Contents#x-contents-anchor">[contents]</a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// The_Blessing_Prayer.vue?acb55818